"use strict";

exports.__esModule = true;
exports.adPlacementPayloadFactory = adPlacementPayloadFactory;
var _index = require("../constants/index.js");
function adPlacementPayloadFactory(payload, isLive) {
  var _payload$dataKeys;
  return {
    ID: isLive ? _index.AD_SOLUTION_ACCOUNT.LIVE : _index.AD_SOLUTION_ACCOUNT.STAGING,
    zoneIDs: payload === null || payload === void 0 ? void 0 : payload.zoneIDs,
    kw: payload === null || payload === void 0 ? void 0 : payload.kw,
    output_json_template_params: true,
    clickmode: 'callback',
    _abdk_json: (_payload$dataKeys = payload === null || payload === void 0 ? void 0 : payload.dataKeys) !== null && _payload$dataKeys !== void 0 ? _payload$dataKeys : {}
  };
}